import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { TextButton } from 'styles/theme-styled';

import {
    EmailLogoSVG,
    FacebookLogo2SVG,
    TwitterLogoSVG,
    WhatsappLogoSVG,
} from 'utils/icons';

import { RedeSocialIconContainer } from './redeSocial-styled';

const RedeSocial = ({ titulo, anuncioId }) => {
    const router = useRouter();

    return (
        <div>
            <h2 style={{ fontSize: '18px' }}>Compartilhe</h2>

            <RedeSocialIconContainer>
                <a
                    href={`https://www.facebook.com/sharer.php?u=${
                        process.env.BASE_URL + router.asPath
                    }`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <TextButton>
                        <Image
                            src={FacebookLogo2SVG}
                            alt="logo facebook"
                            width={24}
                            height={24}
                        />
                    </TextButton>
                </a>

                <a
                    href={`https://twitter.com/intent/tweet?text=${titulo}&url=${
                        process.env.BASE_URL + router.asPath
                    }`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <TextButton>
                        <Image
                            src={TwitterLogoSVG}
                            alt="logo twitter"
                            width={24}
                            height={24}
                        />
                    </TextButton>
                </a>

                <a
                    href={`https://api.whatsapp.com/send?text=${titulo} ${
                        process.env.BASE_URL + router.asPath
                    }`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <TextButton>
                        <Image
                            src={WhatsappLogoSVG}
                            alt="logo whatsapp"
                            width={24}
                            height={24}
                        />
                    </TextButton>
                </a>

                <a
                    href={`mailto:?body=${
                        process.env.BASE_URL + router.asPath
                    }`}
                >
                    <TextButton>
                        <Image
                            src={EmailLogoSVG}
                            alt="logo email"
                            width={24}
                            height={24}
                        />
                    </TextButton>
                </a>
            </RedeSocialIconContainer>
        </div>
    );
};

export default RedeSocial;
